import { render, staticRenderFns } from "./assetsTypeTree.vue?vue&type=template&id=ed8464e2&scoped=true&"
import script from "./assetsTypeTree.vue?vue&type=script&lang=js&"
export * from "./assetsTypeTree.vue?vue&type=script&lang=js&"
import style0 from "./assetsTypeTree.vue?vue&type=style&index=0&id=ed8464e2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8464e2",
  null
  
)

export default component.exports